<template>
  <div class="hype-video">
    <div id="video" />
  </div>
</template>

<script>
export default {
  name: "Video",
  mounted() {
    this.setVideo();
  },
  emits: ["onEnded"],
  methods: {
    setVideo() {
      let video = "https://player.vimeo.com/video/1015386360";      
      const player = new Vimeo.Player("video", {
        url: video,
        responsive: true,
        controls: true,
        loop: false,
        muted: false,
        autoplay: false,
      });
      player.on("ended", this.onEnded);
      this.player = player;
    },
    onEnded() {
      this.$emit("onEnded");
    },
    playVideo() {
      this.player.play();
    },
  },
};
</script>

<style>
</style>